/**
 * SA-1314 (tours spec §3): the one way a component marks a control a tour can point
 * at. The id is typed against the anchor tables, so an unknown id does not compile.
 * Tours and tests change for different reasons, so this is never a test id.
 */
import type { TourAnchorId } from './anchorTables'

export type { TourAnchorId }

export function tourAnchor(id: TourAnchorId): { 'data-tour': TourAnchorId } {
  return { 'data-tour': id }
}
